import React, { useContext } from "react";
import { AlertMessage } from "@eposnow/ui-core";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../../context/UserContext";

interface DashboardOptionErrorProps {
    onDismiss: () => void;
    onRetry: () => void;
}

const DashboardOptionError = ({ onDismiss, onRetry } : DashboardOptionErrorProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { locale } = useContext(UserContext);

    return (
        <AlertMessage
            type="error"
            locale={locale}
            theme={theme}
            styles={{ height: '100%', marginX: 1 }}
            iconAlignment="baseline"
        >
            <Box >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Typography>{t('screens.dashboarding.dataFailedText')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Button sx={{ marginRight: 'auto', fontWeight: 'bold', color: theme.palette.error.dark }} onClick={onDismiss} >
                        {t('screens.dashboarding.dismiss')}
                    </Button>
                    <Button sx={{ marginRight: 'auto', fontWeight: 'bold', color: theme.palette.error.dark }} onClick={onRetry}>
                        {t('screens.dashboarding.retry')}
                    </Button>
                </Box>
            </Box>
        </AlertMessage>
    )
}

export default DashboardOptionError;
